
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class TechnicianTips extends Vue {
  visible = false;
  open() {
    this.visible = true;
  }
  close() {
    this.visible = false;
  }
}
